window.addEventListener('load', () => {
  dialogAction();
});

function dialogAction() {
  const bodyEle = document.querySelector('body');
  const modalEle = document.querySelector('.js-modalEle');
  const modalOverlay = document.querySelector('.js-modalOverlay');
  const modalFigureClose = document.querySelector('.js-modalFigureClose');
  const modalFigure = document.querySelectorAll('.js-modalFigure');
  const modalFigureList = Array.prototype.slice.call(modalFigure, 0);
  const modalFigureSet = document.querySelector('.js-modalFigureSet');
  let selectImg = '';

  modalFigureList.forEach((targetBox) => {
    targetBox.addEventListener('click', () => {
      selectImg = targetBox.dataset.modalimg;
      modalFigureSet.setAttribute('src', selectImg);

      bodyEle.classList.add('is-fixed');
      modalOverlay.classList.add('is-view');
      modalEle.classList.add('is-view');
    });
  });

  modalFigureClose.addEventListener('click', () => {
    console.log('test');
    bodyEle.classList.remove('is-fixed');
    modalOverlay.classList.remove('is-view');
    modalEle.classList.remove('is-view');
    modalFigureSet;
    modalFigureSet.setAttribute('src', '');
  });
}
